export default __webpack_public_path__ + "static/media/Logo.642bc66c.svg";